module.exports = __webpack_public_path__ + "a1139cf679dcd54874e3fb3ce1d69f4c.jpg";